const { goToTopHandler } = layoutJS

$(function () {
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    // asNavFor: '.slider-nav',
    responsive: [
      {
        breakpoint: 599,
        settings: {
          arrows: true,
        },
      },
    ],
  })
  var imgLessThan4 = $('.slider-nav').find('.product_image_small').length
  if (imgLessThan4 <= 4) {
    $('.slider-nav').addClass('no_slick')
    $('.product_image_small').on('click', function () {
      var sliderImg = $(this).attr('data-sliderImg')
      $('.slider-for').slick('slickGoTo', parseInt(sliderImg) - 1)
      $('.product_image_small').removeClass('active')
      $(this).addClass('active')
    })
  } else {
    $('.slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true,
    })
  }

  goToTopHandler()

  $('.favor_item').on('click', function () {
    $(this).toggleClass('added')
  })

  $('.slider-for').on(
    'afterChange',
    function (event, slick, currentSlide, nextSlide) {
      imageZoom('slick-current slick-active', 'img_zoom')
    }
  )

  setTimeout(function () {
    imageZoom('slick-current slick-active', 'img_zoom')
    $('#img_zoom, #lens').hide().css({ opacity: '1' })
  }, 50)

  $('.share').on('click', function () {
    var content = $(this).attr('data-url')
    const el = document.createElement('textarea')
    el.value = content
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    Swal.fire({
      icon: 'success',
      html: '連結複製成功',
      focusConfirm: false,
      confirmButtonText: '關閉',
    })
  })
})

function infoHandler(index) {
  $('.product_info_nav_item').removeClass('active')
  $(`.ni${index}`).addClass('active')
  $('.info_detail>div').hide()
  $(`.info${index}`).fadeIn(300)
}

function productTypeHandler(originalCost, special, idx, sliderImg, inStock) {
  // 市售價、特價、對應classname的編號、輪播圖對應的編號、庫存
  $('.product_category_button').removeClass('active')
  $(`.category${idx}`).addClass('active')
  $('.price font').html(`市售價：${originalCost}元`)
  if (special) {
    $('.price').find('font').css({ color: '#999' })
    $('.price span').show().find('b').html(special)
  } else {
    $('.price').find('font').css({ color: '#333' })
    $('.price span').hide()
  }
  $('.slider-for').slick('slickGoTo', parseInt(sliderImg))
  if (parseInt(sliderImg)) {
    $('.product_image_small')
      .removeClass('active')
      .eq(parseInt(sliderImg))
      .addClass('active')
  }
  if (inStock === 0) {
    $('.quantity_area, .product_buy_button').addClass('sold_out')
  } else {
    $('.quantity_area, .product_buy_button').removeClass('sold_out')
  }
}

var initZoom = false

function imageZoom(imgClass, resultID) {
  var img, img_wrapper, lens, result, cx, cy
  img = document.getElementsByClassName(imgClass)[0]
  result = document.getElementById(resultID)
  img_wrapper = document.getElementById('img_large')
  lens = document.getElementById('lens')
  /* Calculate the ratio between result DIV and lens: */
  // lens.style.width = '120px'
  // lens.style.height = '120px'

  cx = result.offsetWidth / lens.offsetWidth
  cy = result.offsetHeight / lens.offsetHeight
  /* Set background properties for the result DIV */
  result.style.backgroundImage = "url('" + img.src + "')"
  // result.style.backgroundSize = img.width * cx + 'px ' + img.height * cy + 'px'
  result.style.backgroundSize = '1000px 1000px'

  /* Execute a function when someone moves the cursor over the image, or the lens: */
  lens.addEventListener('mousemove', moveLens)
  img.addEventListener('mousemove', moveLens)
  img_wrapper.addEventListener('mouseenter', enterImg)
  img_wrapper.addEventListener('mouseleave', leaveImg)

  /* And also for touch screens: */
  // lens.addEventListener('touchmove', moveLens)
  // img.addEventListener('touchmove', moveLens)
  function moveLens(e) {
    var pos, x, y
    /* Prevent any other actions that may occur when moving over the image */
    e.preventDefault()
    /* Get the cursor's x and y positions: */
    pos = getCursorPos(e)
    /* Calculate the position of the lens: */
    x = pos.x - lens.offsetWidth / 2
    y = pos.y - lens.offsetHeight / 2
    /* Prevent the lens from being positioned outside the image: */
    if (x > img.width - lens.offsetWidth) {
      x = img.width - lens.offsetWidth
    }
    if (x < 0) {
      x = 0
    }
    if (y > img.height - lens.offsetHeight) {
      y = img.height - lens.offsetHeight
    }
    if (y < 0) {
      y = 0
    }
    /* Set the position of the lens: */
    lens.style.left = x + 'px'
    lens.style.top = y + 'px'
    /* Display what the lens "sees": */
    result.style.backgroundPosition = '-' + x * cx + 'px -' + y * cy + 'px'
  }
  function getCursorPos(e) {
    var a,
      x = 0,
      y = 0
    e = e || window.event
    /* Get the x and y positions of the image: */
    a = img.getBoundingClientRect()
    /* Calculate the cursor's x and y coordinates, relative to the image: */
    x = e.pageX - a.left
    y = e.pageY - a.top
    /* Consider any page scrolling: */
    x = x - window.pageXOffset
    y = y - window.pageYOffset
    return { x: x, y: y }
  }
  function enterImg(e) {
    lens.style.display = 'block'
    result.style.display = 'block'
  }
  function leaveImg(e) {
    lens.style.display = 'none'
    result.style.display = 'none'
  }
}
